import { Injectable } from '@angular/core';
import { AsyncValidator, AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors} from '@angular/forms';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiService} from "../api.service";

@Injectable()
export class EmailRegisteredValidator implements AsyncValidator {
    constructor(private apiService: ApiService) {}

    validate = (ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null>  => {
        return this.apiService.isEmailRegistered(ctrl.value).pipe(
            map(response => (response ? { emailAlreadyRegistered: true } : null))
        );
    }
}